import React from 'react'
import { ListOffer } from 'dealer-types'
import { ItemProvider } from 'src/contexts/itemContext'
import RealizationItem from './RealizationItem'

const RealizationItemWrapper = (props: ListOffer): JSX.Element => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore
    <ItemProvider {...props}>
      <RealizationItem />
    </ItemProvider>
  )
}

export default RealizationItemWrapper
